import type { NodeDefinition } from '../../../types/node-definition';

/**
 * Respond to Trigger Node Definition
 * 
 * This node sends a custom response back to the trigger (Chat or Webhook) and optionally commits it to memory.
 * It's designed to work with Chat Trigger and Webhook Trigger workflows to provide custom responses.
 * 
 * Features:
 * - Send custom text responses
 * - Works with both Chat and Webhook triggers
 * - Optionally commit responses to conversation memory (Chat only)
 * - Pass through metadata
 * - Support for different response types (text/json)
 * 
 * Use Cases:
 * - Custom greeting messages in chat
 * - Webhook responses with processed data
 * - Formatted responses after processing
 * - Conditional responses based on workflow logic
 * - Responses that need to be saved to memory
 */
const definition: NodeDefinition = {
  type: 'respond-to-trigger',
  name: 'Respond to Trigger',
  description: 'Send a custom response back to the trigger (Chat or Webhook)',
  version: '1.0.0',
  
  category: 'responses',
  icon: 'MessageSquare',
  color: 'blue',
  
  group: ['output'],
  
  defaults: {
    name: 'Respond to Trigger',
    color: 'blue'
  },
  
  subtitle: 'Send response to trigger',
  
  inputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Input',
      required: false
    }
  ],
  
  outputs: [
    {
      name: 'main',
      type: 'main',
      displayName: 'Output'
    }
  ],
  
  credentials: [],
  
  tags: ['response', 'trigger', 'chat', 'webhook', 'message', 'output'],
  
  metadata: {
    author: 'Evo E2E Team',
    documentation: 'https://docs.evoe2e.com/nodes/respond-to-trigger'
  },
  
  comingSoon: false
};

export default definition;
